// extracted by mini-css-extract-plugin
export default {"canvas":"BirdModel_canvas__MfcXV","model":"BirdModel_model__s3qj8","model__wrapper":"BirdModel_model__wrapper__xxFNw"};